"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var variables = _interopRequireWildcard(require("../../variables.js"));

var _this = void 0,
    _jsxFileName = "/Users/cedricdelpoux/Development/perso/react-demo-page/src/components/Button/index.js";

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  color: rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.08);\n  transition: color 0.2s, background-color 0.2s, border-color 0.2s;\n\n  @media ", ", ", " {\n    &:hover {\n      color: rgba(255, 255, 255, 0.8);\n      text-decoration: none;\n      background-color: rgba(255, 255, 255, 0.2);\n      border-color: rgba(255, 255, 255, 0.3);\n    }\n  }\n\n  @media ", " {\n    padding: 0.75rem 1rem;\n  }\n\n  @media ", " {\n    padding: 0.6rem 0.9rem;\n    font-size: 0.9rem;\n  }\n\n  @media ", " {\n    padding: 0.75rem;\n    font-size: 0.9rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var StyledButton = _styledComponents["default"].span(_templateObject(), variables.large, variables.medium, variables.large, variables.medium, variables.small);

exports.StyledButton = StyledButton;

var Button = function Button(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledButton, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 3
    }
  }, children);
};

Button.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].string.isRequired
} : {};
var _default = Button;
exports["default"] = _default;